import { Label } from "@mui/icons-material";
import { IConfig } from "unleash-proxy-client";
export type CodeType =
  | "retail_grocery_title_normal"
  | "retail_agricultural"
  | "retail_electronic"
  | "retail_fashion"
  | "retail_cosmetics";
export const getDescriptionThemeByCategoryCode = (code: string) => {
  switch (code) {
    case "retail_grocery_title_slide":
      return "Giao diện được thiết kế để phục vụ cho các trang web liên quan đến tạp hóa, cửa hàng tạp hóa hoặc siêu thị mini. Những themes này thường có những tính năng và chức năng đặc biệt để giúp các chủ cửa hàng tạp hóa dễ dàng quản lý và bán hàng trực tuyến.";
    case "retail_agricultural":
      return "Giao diện được thiết kế để phục vụ cho các trang web liên quan đến sản xuất, kinh doanh và tiêu thụ nông sản. Những themes này thường có thiết kế đẹp mắt, chuyên nghiệp và hỗ trợ tính năng quản lý nội dung để giúp các chủ trang web quản lý nội dung một cách dễ dàng và hiệu quả.";
    case "retail_electronic":
      return "Giao diện được thiết kế để phục vụ cho các trang web liên quan đến kinh doanh và bán lẻ các sản phẩm điện tử và điện máy. Những themes này thường có giao diện đẹp mắt, chuyên nghiệp và hỗ trợ tính năng quản lý nội dung để giúp các chủ trang web quản lý nội dung một cách dễ dàng và hiệu quả.";
    case "retail_fashion":
      return "Giao diện được thiết kế để phục vụ cho các trang web bán lẻ các sản phẩm thời trang và phụ kiện. Những themes này thường có giao diện đẹp mắt, chuyên nghiệp và hỗ trợ tính năng quản lý nội dung để giúp các chủ trang web quản lý nội dung một cách dễ dàng và hiệu quả.";
    case "retail_cosmetics":
      return "Giao diện được thiết kế sẵn để sử dụng cho các trang web kinh doanh mỹ phẩm. Nó bao gồm các tính năng, mẫu thiết kế và chức năng phù hợp để giúp các chủ doanh nghiệp mỹ phẩm tạo ra một trang web chuyên nghiệp và thu hút khách hàng.";
    case "diner_1":
    case "diner_2":
    case "diner_3":
    case "restaurant_1":
      return "Giao diện được thiết kế để phục vụ cho các trang web nhà hàng, quán ăn...giúp hiển thị thực đơn và dịch vụ một cách sinh động. Khách hàng có thể dễ dàng tìm hiểu về các món ăn, đồ uống, và đặt hàng trực tuyến, tạo nên trải nghiệm tiện lợi và hấp dẫn.";
    case "cafe_1":
      return "Giao diện được thiết kế để phục vụ cho các trang web quán cà phê, giúp hiển thị menu và dịch vụ một cách sinh động. Khách hàng có thể dễ dàng khám phá các loại đồ uống, món ăn nhẹ, và đặt hàng trực tuyến, mang lại trải nghiệm tiện lợi và thu hút.";
    default:
      return "";
  }
};
export const getDescriptionThemeByCategoryCodeFnB = (code: string) => {
  switch (code) {
    case "basic":
      return {
        label:
          "Giao diện được thiết kế để phục vụ các nhà hàng, quán ăn, cà phê,... giới thiệu thực đơn của họ cho khách hàng của mình và tạo điều kiện thuận lợi cho khách hàng khi chọn món và đặt hàng.",
        key: "FNB_DESCRIPTION_BASIC",
      };
    case "fastfood":
      return {
        Label:
          "Giao diện được thiết kế đơn giản nhưng hấp dẫn, để thu hút sự chú ý của khách hàng và giúp họ dễ dàng tìm kiếm thông tin về menu và các dịch vụ của cà phê, đồ ăn nhanh, Take Away",
        key: "FNB_DESCRIPTION_FAST_FOOD",
      };
    case "bakery":
      return {
        label:
          "Giao diện được thiết kế đơn giản, dễ sử dụng và tập trung vào việc hiển thị các sản phẩm bánh ngọt và đồ ăn vặt. Khách hàng có thể tham khảo và quyết định chọn lựa các sản phẩm của cửa hàng.",
        key: "FNB_DESCRIPTION_BAKERY",
      };
    case "orderfood":
      return {
        label:
          "Giao diện được thiết kế sẵn để hiển thị thông tin về các món ăn và dịch vụ của nhà hàng, đặt bàn trực tuyến sẽ giúp khách hàng dễ dàng đặt bàn một cách thuận tiện và nhanh chóng.",
        key: "FNB_DESCRIPTION_ORDERFOOD",
      };
    case "cafe":
      return {
        label:
          "Giao diện được thiết kế đơn giản nhưng hấp dẫn, để thu hút sự chú ý của khách hàng và giúp họ dễ dàng tìm kiếm thông tin về menu và các dịch vụ của cà phê, đồ ăn nhanh, Take Away",
        key: "FNB_DESCRIPTION_CAFE",
      };
    case "buffet":
      return {
        label:
          "Giao diện được thiết kế đơn giản, dễ sử dụng và tập trung vào việc hiển thị các sản phẩm bánh ngọt và đồ ăn vặt. Khách hàng có thể tham khảo và quyết định chọn lựa các sản phẩm của cửa hàng.",
        key: "FNB_DESCRIPTION_BUFFET",
      };
    case "saloon":
      return {
        label:
          "Giao diện được thiết kế thiết kế để hiển thị thông tin về các món ăn và dịch vụ của quán ăn một cách rõ ràng và dễ dàng tìm kiếm tìm kiếm món ăn mà họ muốn.",
        key: "FNB_DESCRIPTION_SALOON",
      };
    case "karaoke":
      return {
        label:
          "Giao diện được thiết kế sẵn để hiển thị danh sách các dịch vụ của karaoke, bar và đặt phòng trực tuyến sẽ giúp khách hàng dễ dàng đặt phòng một cách thuận tiện và nhanh chóng.",
        key: "FNB_DESCRIPTION_KARAOKE",
      };
    case "diner_1":
    case "diner_2":
    case "diner_3":
    case "restaurant_1":
      return {
        label:
          "Giao diện được thiết kế để phục vụ cho các trang web nhà hàng, quán ăn...giúp hiển thị thực đơn và dịch vụ một cách sinh động. Khách hàng có thể dễ dàng tìm hiểu về các món ăn, đồ uống, và đặt hàng trực tuyến, tạo nên trải nghiệm tiện lợi và hấp dẫn.",
        key: "FNB_DESCRIPTION_RESTAURANT",
      };
    case "cafe_1":
      return {
        label:
          "Giao diện được thiết kế để phục vụ cho các trang web quán cà phê, giúp hiển thị menu và dịch vụ một cách sinh động. Khách hàng có thể dễ dàng khám phá các loại đồ uống, món ăn nhẹ, và đặt hàng trực tuyến, mang lại trải nghiệm tiện lợi và thu hút.",
        key: "FNB_DESCRIPTION_CAFE_ONE",
      };
    default:
      return {
        label:
          "Giao diện được thiết kế để phục vụ các nhà hàng, quán ăn, cà phê,... giới thiệu thực đơn của họ cho khách hàng của mình và tạo điều kiện thuận lợi cho khách hàng khi chọn món và đặt hàng.",
        key: "FNB_DESCRIPTION_DEFAULT",
      };
  }
};

export const getShortCategoryNameByCode = (code: string) => {
  switch (code) {
    case "retail_grocery_title_normal":
      return "Tạp hóa";
    case "retail_agricultural":
      return "Nông sản";
    case "retail_electronic":
      return "Điện máy";
    case "retail_fashion":
      return "Thời trang";
    case "retail_cosmetics":
      return "Mỹ phẩm";
    default:
      return "";
  }
};

export const getShortCategoryNameByCodeFnB = (code: string) => {
  switch (code) {
    case "basic":
      return ["Cà phê", "Quán ăn", "Ăn vặt"];
    case "bakery":
      return ["Bánh ngọt", "Ăn vặt"];
    case "orderfood":
      return ["Cafe", "Nhà hàng"];
    case "cafe":
      return ["Cà phê", "Đồ ăn nhanh"];
    case "saloon":
      return ["Quán ăn", "Ăn vặt"];
    case "karaoke":
      return ["Bar", "Karaoke"];
    case "diner_1":
    case "diner_2":
    case "diner_3":
      return ["Quán ăn"];
    case "cafe_1":
      return ["Cafe"];
    case "restaurant_1":
      return ["Nhà hàng"];
    default:
      return [];
  }
};

export const getShortCategoryNameByCodeV2 = (code: string) => {
  switch (code) {
    case "retail_grocery_title_normal":
      return "grocery";
    case "retail_agricultural":
      return "agricultural";
    case "retail_electronic":
      return "electronic";
    case "retail_fashion":
      return "fashion";
    case "retail_cosmetics":
      return "cosmetic";
    default:
      return "";
  }
};

export const getShortCategoryNameByCodeFnBV2 = (code: string) => {
  switch (code) {
    case "basic":
      return ["cafe", "dinner", "snack"];
    case "bakery":
      return ["cake", "snack"];
    case "orderfood":
      return ["cafe", "restaurant"];
    case "cafe":
      return ["cafe", "fastfood"];
    case "saloon":
      return ["dinner", "snack"];
    case "karaoke":
      return ["bar", "karaoke"];
    case "diner_1":
    case "diner_2":
    case "diner_3":
      return ["dinner"];
    case "cafe_1":
      return ["cafe"];
    case "restaurant_1":
      return ["restaurant"];
    default:
      // get string before last "_" of string, example: "retail_grocery_title_normal" => "retail_grocery_title"
      let parts = code.split("_");
      let result: string[] = []
      if (parts.length > 1) {
        result = [parts.slice(0, -1).join("_") as string];
      }
      return result;
  }
};

export const unleashConfig: IConfig = {
  url: process.env.REACT_APP_UNLEASH_URL || "",
  clientKey: process.env.REACT_APP_UNLEASH_API_KEY || "",
  refreshInterval: 0, // How often (in seconds) the client should poll the proxy for updates
  appName: "default",
  environment: "development",
}
